let accordions;
let container;

const openAccordion = (accordion) => {
  const content = accordion.querySelector(".accordion__item__dropdown");
  const icon = accordion.querySelector(".accordion__item__icon");
  accordion.classList.add("accordion__item__dropdown--active");
  icon.classList.add("accordion__item__icon--active");
  const contentHeight = content.scrollHeight;
  content.style.paddingTop = "24px";
  content.style.paddingBottom = "24px";
  content.style.maxHeight = contentHeight + 48 + "px";
};

const closeAccordion = (accordion) => {
  const content = accordion.querySelector(".accordion__item__dropdown");
  const icon = accordion.querySelector(".accordion__item__icon");
  accordion.classList.remove("accordion__item__dropdown--active");
  icon.classList.remove("accordion__item__icon--active");
  content.style.maxHeight = null;
  content.style.paddingTop = null;
  content.style.paddingBottom = null;
};
